<div class="row mcr">
  <div class="col-md-6 form">

    <div class="logo1">
      <img src=".\assets\images\solapur_logo.png">
    </div>

    <h1 style="text-align: center; color: DodgerBlue;">Register</h1>
    
    <nb-alert *ngIf="showMessages.error && errors?.length && !submitted" outline="danger" role="alert">
      <p class="alert-title"><b>Oh snap!</b></p>
      <ul class="alert-message-list">
        <li *ngFor="let error of errors" class="alert-message">{{ error }}</li>
      </ul>
    </nb-alert>
    
    <nb-alert *ngIf="showMessages.success && messages?.length && !submitted" outline="success" role="alert">
      <p class="alert-title"><b>Hooray!</b></p>
      <ul class="alert-message-list">
        <li *ngFor="let message of messages" class="alert-message">{{ message }}</li>
      </ul>
    </nb-alert>
    
    <div [formGroup]="registerForm" aria-labelledby="title">
    
      <div class="form-control-group">
        <label for="input-name">First Name:</label>
        <input nbInput autofocus fullWidth fieldSize="large" id="input-name" formControlName="firstName"
          [status]="firstName.dirty ? (firstName.invalid  ? 'danger' : 'success') : ''"
          [attr.aria-invalid]="firstName.invalid && firstName.touched ? true : null" placeholder="First Name">
        <div>
          <span style="color:red"
            *ngIf="registerForm.controls.firstName.errors?.required&&(registerForm.controls.firstName.dirty||registerForm.controls.firstName.touched)">FirstName
            is required</span>
          <!-- <span style="color :red" *ngIf="registerForm.controls.firstName.errors?.pattern">Please enter valid
            firstName</span> -->
        </div>
      </div>
    
      <div class="form-control-group">
        <label for="input-name">Last Name:</label>
        <input nbInput autofocus fullWidth fieldSize="large" id="input-name" formControlName="lastName"
          [status]="lastName.dirty ? (lastName.invalid  ? 'danger' : 'success') : ''"
          [attr.aria-invalid]="lastName.invalid && lastName.touched ? true : null" placeholder="Last Name">
        <div>
          <span style="color:red"
            *ngIf="registerForm.controls.lastName.errors?.required&&(registerForm.controls.lastName.dirty||registerForm.controls.lastName.touched)">LastName
            is required</span>
          <!-- <span style="color :red" *ngIf="registerForm.controls.lastName.errors?.pattern">Please enter valid
            firstName</span> -->
        </div>
      </div>
    
      <div class="form-control-group">
    
        <div>
          <label for="inputMobile"> Whatsapp Country Code and Mobile number <span style="color:red;">* </span><i
              class="fa fa-info-circle" nbPopoverMode="hover"></i></label>
        </div>
      </div>
      <div class="form-control-group">
        <div></div>
    
        <div>
          <div class="form-group">
            <input nbInput type="text" class="form-control" placeholder="Mobile No" fullWidth
              fieldSize="large" formControlName="mobile" class="countrycode" inputmode="numeric" digitOnly ng2TelInput
              [ng2TelInputOptions]="{separateDialCode:true}" (countryChange)="onCountryChange($event)" pattern="[0-9]{10,15}"
              (keypress)="OnlyNoAllowed($event)" required>
            <div>
              <span style="color:red"
                *ngIf="registerForm.controls.mobile.errors?.required&&(registerForm.controls.mobile.dirty||registerForm.controls.mobile.touched)">Mobile
                Number is required</span><br>
              <span style="color :red" *ngIf="registerForm.controls.mobile.invalid && (registerForm.controls.mobile.dirty || registerForm.controls.mobile.touched)">Please enter valid mobile
                number</span>
            </div>
          </div>
        </div>
      </div>
    
    
      <div class="form-control-group">
        <label for="input-name">Name On Marksheet/Transcript/Degree:</label>
        <input nbInput autofocus fullWidth fieldSize="large" id="input-name" formControlName="fullname"
          placeholder="Name as per marksheet/transcript/degree">
        <div>
          <span style="color:red"
            *ngIf="registerForm.controls.fullname.errors?.required&&(registerForm.controls.fullname.dirty||registerForm.controls.fullname.touched)">Full
            Name is required</span>
          <!-- <span style="color :red" *ngIf="registerForm.controls.fullname.errors?.pattern">Please enter valid Full
            Name</span> -->
        </div>
      </div>
    
      <div class="form-control-group">
        <div>
          <label>Gender</label><br>
          <input type="radio" id="male" formControlName="gender" name="gender" value="male">
            <label for="male">Mr.(Male)</label>
            <input type="radio" id="female" formControlName="gender" name="gender" value="female">
            <label for="female">Ms.(Female)</label>
            <input type="radio" id="others" formControlName="gender" name="gender" value="transgender">
            <label for="others">Others</label>
        </div>
      </div>
    
<!--     
      <div class="form-control-group">
        <label for="input-course">Courses:</label>
        <br>
        <input type="text" class="form-control" placeholder="Select Course" aria-label="Select Course" nbInput
          [nbAutocomplete]="auto" [formControl]="courseCntrl"><span style="color:red" *ngIf="show_course">Please Select
          Course</span>
        <nb-autocomplete #auto>
          <nb-option *ngFor="let course of filteredCourses | async">
            <div (click)="optionClicked($event, course)"> <nb-checkbox [checked]="course.selected"
                (change)="toggleSelection(course)" (click)="$event.stopPropagation()"> {{ course.course }} </nb-checkbox>
            </div>
          </nb-option>
        </nb-autocomplete>
      </div> -->
    
      <!-- <div width="100%">
        <label for="input-course">PRN Number for Selected Courses :</label>
        <nb-list dense>
          <nb-list-item *ngFor="let course of course_enroll">
            {{course.course}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <input nbInput fullWidth formControlName="enrollment" pattern="[0-9]{12,16}"
              (blur)="setEnrollmentNo(course.course,course.degree_type,$event)" (keypress)="OnlyNoAllowed($event)"><br />
              <span *ngIf="registerForm.controls.enrollment.invalid && (registerForm.controls.enrollment.dirty || registerForm.controls.enrollment.touched )">
                <span   style="color:red;">Please enter valid PRN Number</span></span>
          </nb-list-item>
        </nb-list>
    
      </div> -->
    
      <div class="form-control-group">
        <label for="input-aadhar">Aadhar Card Number/Passport No : </label>
        <input nbInput fullWidth type="text" fieldSize="large" id="input-aadhar"  pattern="[0-9]{12,12}"
          (keypress)="OnlyNoAllowed($event)" formControlName="aadhar" placeholder="Adhar Card Number">
          <span *ngIf="registerForm.controls.aadhar.invalid && (registerForm.controls.aadhar.dirty || registerForm.controls.aadhar.touched )">
            <span style="color:red;">Please enter valid Adhar/Passport Number</span></span><br>  
        <span
          *ngIf="registerForm.controls.aadhar.invalid && (registerForm.controls.aadhar.dirty || registerForm.controls.aadhar.touched)"><span
            style="color:red;">Aadhar Card Number or Passport no is required</span></span>
      </div>
    
      <div class="form-control-group">
        <label for="input-email">Email address:</label>
        <input nbInput (keyup)="onKeyPressNew($event)" fullWidth fieldSize="large" id="input-email" formControlName="email"
          [status]="email.dirty ? (email.invalid  ? 'danger' : 'success') : ''"
          [attr.aria-invalid]="email.invalid && email.touched ? true : null" placeholder="Email address">
        <div>
          <span style="color:red"
            *ngIf="registerForm.controls.email.errors?.required&&(registerForm.controls.email.dirty||registerForm.controls.email.touched)">Email
            is required</span>
          <!-- <span style="color :red" *ngIf="registerForm.controls.email.errors?.pattern">Please enter valid Email Id</span> -->
        </div>
        <span style="color : red" *ngIf="emailExists == true">Email already exists.</span><br />
        <span style="color: red;">All communication regarding your appliction will be sent on this email Id kindly share an
          active email Id.</span>
      </div>
    
      <div class="form-control-group">
        <input nbInput hidden fullWidth fieldSize="large" id="input-email" formControlName="currentlocation">
      </div>
      <div class="form-control-group">
        <label for="input-password">Password:</label>
        <input nbInput fullWidth fieldSize="large" id="input-password" formControlName="password" type="password"
          [status]="password.dirty ? (password.invalid  ? 'danger' : 'success') : ''" placeholder="Password">
        <span
          *ngIf="registerForm.controls.password.invalid && (registerForm.controls.password.dirty || registerForm.controls.password.touched)"><span
            style="color:red;">Password is required</span></span>
      </div>
    
      <div class="form-control-group">
        <label for="input-re-password">Confirm Password:</label>
        <input nbInput fullWidth fieldSize="large" id="input-re-password" formControlName="confirmPassword" type="password"
          [status]="confirmPassword.dirty ? (confirmPassword.invalid || password.value != confirmPassword.value  ? 'danger' : 'success') : ''"
          placeholder="Password">
        <p class="caption status-danger" *ngIf="password.value != confirmPassword.value">
          Password and confirm password does not match!
        </p>
      </div>
    
    
      <button nbButton fullWidth status="primary" size="large" [disabled]="submitted || !registerForm.valid || 
      password.value != confirmPassword.value || emailExists" [class.btn-pulse]="submitted"
        (click)="openTermsPopup()">
        Proceed
      </button>
    </div>
    <h6 class="login1" aria-label="Sign in">
      Already have an account? <a class="text-link" style="color:DodgerBlue;" routerLink="../login">Log in</a>
    </h6>
  </div>

  <div class="col-md-6 about">
    <div class="elip"></div>
    <div class="logo">
      <img src=".\assets\images\solapur_logo.png" style="width: 190px" alt="logo">
    </div>

    <div style="position: relative; ">
      <div style="position: absolute; z-index: 5; width: 100%;">
        <h4> Already have an account? <a style="color:DodgerBlue;" class="text-link" routerLink="../login">Login</a>
        </h4>
      </div>
    </div>

    <div class="imge">
      <img src="./../../../../assets/images/Recruitment Agencies ( verification).svg">
    </div>
  </div>
</div>


<p-dialog [(visible)]="displayNo" [modal]="true" [responsive]="true" [resizable]="false" [minY]="70"
  [baseZIndex]="10000">
  <div class="row">
    <div class="col-lg-1"></div>
    <div class="col-lg-11">
      <nb-checkbox [checked]="checked1" (checkedChange)="toggle1('condition1',$event)"> I am aware that the Solapur
        University/colleges that I am considering for application may communicate with me by mail, email, phone or text
        message/Whatsapp for my application.</nb-checkbox>



    </div>
  </div><br>
  <div class="row">
    <div class="col-lg-1"></div>
    <div class="col-lg-11">
      <nb-checkbox [checked]="checked2" (checkedChange)="toggle1('condition2',$event)">
        By checking this box, I represent that (i) I am age 13 or older and (ii) I have read, understood and agreed to
        the terms and conditions of the Terms of Use and Privacy Policy (unless I am over the age of 13 but under the
        age of 18, in which case, my parent or legal guardian has also read, understood and agreed to the terms and
        conditions of the Privacy Policy and Terms of Use sections).

      </nb-checkbox>
    </div>
  </div><br>
  <div class="row">
    <div class="col-lg-1"></div>
    <div class="col-lg-11">
      <nb-checkbox [checked]="checked3" (checkedChange)="toggle1('condition3',$event)">
        I accept that (I) Fees paid is not refundable And (II) All the information filled by me is true.

      </nb-checkbox>
    </div>
  </div><br>
  <div class="row">
    <div class="col-lg-1"></div>
    <div class="col-lg-11">
      <nb-checkbox [checked]="checked4" (checkedChange)="toggle1('condition4',$event)">
        Solapur University website uses small files stored on your computer, known as cookies, that help us remember
        your settings and ensure the website works properly. By continuing, I am agreeing to The Solapur University use
        of cookies.
      </nb-checkbox>
    </div>
  </div><br>

  <button nbButton fullWidth status="primary" size="large"
    [disabled]="submitted || !registerForm.valid || password.value != confirmPassword.value || !checked3 || !checked4"
    [class.btn-pulse]="submitted" (click)="register()">
    Register
  </button>
</p-dialog>


<p-dialog [(visible)]="emailverify" [modal]="true" [responsive]="true" [resizable]="false" [minY]="70"
  [baseZIndex]="10000">
  <h3>Kindly Change your Email Address</h3>

</p-dialog>



<p-dialog [(visible)]="showInstructions" [modal]="true" [style]="{width: '70vw'}">
  <nb-card class="pdf">
    <nb-card-body>
      <div class="pdf-container">
        <pdf-viewer [src]="arr" [render-text]="true" style="display: block;"></pdf-viewer>
      </div>
    </nb-card-body>
  </nb-card>
</p-dialog>

<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>